module.exports = __webpack_public_path__ + "img/Z71_07.8c77c5b6.jpg";